import { gql } from '@apollo/client';
import commentFragment from './commentFragment';

const CREATE_EVENT_COMMENT = gql`
  mutation CreateEventComment($comment: CreateAppraiserEventCommentInput!) {
    createEventComment(comment: $comment) {
      ...CommentFields
    }
  }

  ${commentFragment}
`;

export default CREATE_EVENT_COMMENT;
